/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserEntity } from './UserEntity';
import {
    UserEntityFromJSON,
    UserEntityFromJSONTyped,
    UserEntityToJSON,
    UserEntityToJSONTyped,
} from './UserEntity';

/**
 * 
 * @export
 * @interface ProcessHistoryDiffEntity
 */
export interface ProcessHistoryDiffEntity {
    /**
     * プロセス履歴ID
     * @type {string}
     * @memberof ProcessHistoryDiffEntity
     */
    id: string;
    /**
     * 直前に行った操作
     * @type {string}
     * @memberof ProcessHistoryDiffEntity
     */
    type: string;
    /**
     * データ差分
     * @type {object}
     * @memberof ProcessHistoryDiffEntity
     */
    dataDiffs: object;
    /**
     * 更新日時
     * @type {Date}
     * @memberof ProcessHistoryDiffEntity
     */
    updatedAt: Date;
    /**
     * 更新者
     * @type {UserEntity}
     * @memberof ProcessHistoryDiffEntity
     */
    updatedBy: UserEntity;
    /**
     * プロセスステータス
     * @type {string}
     * @memberof ProcessHistoryDiffEntity
     */
    status: string;
    /**
     * 操作するノード
     * @type {object}
     * @memberof ProcessHistoryDiffEntity
     */
    actionFromNode: object;
    /**
     * 操作して変化したノード
     * @type {Array<object>}
     * @memberof ProcessHistoryDiffEntity
     */
    actionToNodes: Array<object>;
    /**
     * 現在のノード
     * @type {Array<object>}
     * @memberof ProcessHistoryDiffEntity
     */
    currentNodes: Array<object>;
    /**
     * 復元元のプロセス履歴ID
     * @type {string}
     * @memberof ProcessHistoryDiffEntity
     */
    restoredFromHistoryId?: string;
    /**
     * 復元スコープ
     * @type {string}
     * @memberof ProcessHistoryDiffEntity
     */
    restoredScope?: ProcessHistoryDiffEntityRestoredScopeEnum;
}


/**
 * @export
 */
export const ProcessHistoryDiffEntityRestoredScopeEnum = {
    All: 'all',
    Data: 'data',
    State: 'state'
} as const;
export type ProcessHistoryDiffEntityRestoredScopeEnum = typeof ProcessHistoryDiffEntityRestoredScopeEnum[keyof typeof ProcessHistoryDiffEntityRestoredScopeEnum];


/**
 * Check if a given object implements the ProcessHistoryDiffEntity interface.
 */
export function instanceOfProcessHistoryDiffEntity(value: object): value is ProcessHistoryDiffEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('dataDiffs' in value) || value['dataDiffs'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('actionFromNode' in value) || value['actionFromNode'] === undefined) return false;
    if (!('actionToNodes' in value) || value['actionToNodes'] === undefined) return false;
    if (!('currentNodes' in value) || value['currentNodes'] === undefined) return false;
    return true;
}

export function ProcessHistoryDiffEntityFromJSON(json: any): ProcessHistoryDiffEntity {
    return ProcessHistoryDiffEntityFromJSONTyped(json, false);
}

export function ProcessHistoryDiffEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessHistoryDiffEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'dataDiffs': json['dataDiffs'],
        'updatedAt': (new Date(json['updatedAt'])),
        'updatedBy': UserEntityFromJSON(json['updatedBy']),
        'status': json['status'],
        'actionFromNode': json['actionFromNode'],
        'actionToNodes': json['actionToNodes'],
        'currentNodes': json['currentNodes'],
        'restoredFromHistoryId': json['restoredFromHistoryId'] == null ? undefined : json['restoredFromHistoryId'],
        'restoredScope': json['restoredScope'] == null ? undefined : json['restoredScope'],
    };
}

export function ProcessHistoryDiffEntityToJSON(json: any): ProcessHistoryDiffEntity {
    return ProcessHistoryDiffEntityToJSONTyped(json, false);
}

export function ProcessHistoryDiffEntityToJSONTyped(value?: ProcessHistoryDiffEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'dataDiffs': value['dataDiffs'],
        'updatedAt': ((value['updatedAt']).toISOString()),
        'updatedBy': UserEntityToJSON(value['updatedBy']),
        'status': value['status'],
        'actionFromNode': value['actionFromNode'],
        'actionToNodes': value['actionToNodes'],
        'currentNodes': value['currentNodes'],
        'restoredFromHistoryId': value['restoredFromHistoryId'],
        'restoredScope': value['restoredScope'],
    };
}

